import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
class ProductsSlider {
  constructor(element) {
    this.elem = element;
    this.init();
  }
  init() {
    this.initSelects();
    this.initNav();
    this.initSwiper();
  }
  initNav() {
    const links = this.elem.querySelectorAll('.ce-products-list__nav__item__link');
    links.forEach(link => {
      link.addEventListener('click', async e => {
        e.preventDefault();
        this.elem.classList.add('__loading');
        const data = await this.getProducts(e.currentTarget.href);
        this.updateProducts(data);
        this.elem.classList.remove('__loading');
      });
    });
  }
  initSelects() {
    const selects = this.elem.querySelectorAll('select');
    selects.forEach(select => {
      select.addEventListener('change', e => {
        if (e.target.value) {
          window.location.href = e.target.value;
        }
      });
    });
  }
  initSwiper() {
    const swiperContainer = this.elem.querySelector('.swiper');
    if (!swiperContainer) return;
    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: this.elem.querySelector('.swiper-button-next'),
        prevEl: this.elem.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        768: {
          spaceBetween: 20
        },
        992: {
          spaceBetween: 40
        }
      }
    });
  }
  async getProducts(href) {
    const response = await fetch(href);
    const products = await response.text();
    return products;
  }
  updateProducts(data) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const updatedProductsList = doc.querySelector('.ce-products-list');
    if (updatedProductsList) {
      this.elem.innerHTML = updatedProductsList.innerHTML;
      this.init();
      window.dispatchEvent(new Event('resize'));
    }
  }
}
export default () => {
  const productsListElements = document.querySelectorAll('.ce-products-list');
  productsListElements.forEach(productsListElement => {
    new ProductsSlider(productsListElement);
  });
};